import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";

import Header from "../../components/Header/";
import Sidebar from "../../components/Sidebar/";
import Breadcrumb from "../../components/Breadcrumb/";
import Aside from "../../components/Aside/";
import NaikKelas from "../../views/NaikKelas/";
import Dashboard from "../../views/Dashboard/";

// halaman ku
import TahunAjar from "../../views/TahunAjar/";
import Mapel from "../../views/Mapel/";
import Kelas from "../../views/Kelas/";
import Event from "../../views/Event/";
import News from "../../views/News/";
import Help from "../../views/Help/";
import Prestasi from "../../views/Prestasi/";
import Pengumuman from "../../views/Pengumuman/";
import StaticPage from "../../views/StaticPage/";
import Jadwal from "../../views/Jadwal/";
import Profil from "../../views/Profil/";
import Users from "../../views/Users/";
import Tugas from "../../views/Tugas/";
import Materi from "../../views/Materi/";
import Video from "../../views/Video/";
import Exam from "../../views/Exam/";
import Online from "../../views/Monitoring/";
import Chat from "../../views/Chat/";
import Spp from "../../views/Spp/";
import Soal from "../../views/Soal/";
import Libur from "../../views/Libur/";
import ReportPresensi from "../../views/ReportPresensi/";
import MasterIuran from "../../views/MasterIuran/";
import DiskonIuran from "../../views/DiskonIuran/";
import ForwardIuran from "../../views/ForwardIuran/";
import JenisIuran from "../../views/JenisIuran/";
import GroupIuran from "../../views/GroupIuran/";
import IuranSiswa from "../../views/IuranSiswa/";
import DataPasien from "../../views/DataPasien/";
import Transaksi from "../../views/Transaksi/";
import HistoriTransaksi from "../../views/HistoriTransaksi/";
import Penagihan from "../../views/Penagihan/";

import Setting from "../../views/Setting/";
import Shift from "../../views/Shift/";
import Arsip from "../../views/Arsip";

const App = props => (
	<div className="app">
		<Header />
		<div className="app-body">
			<Sidebar {...props} />
			<main className="main">
				<Breadcrumb />

				<div className="container-fluid">
					<Switch>
						<Route path="/dashboard" name="Dashboard" component={Dashboard} />
						<Route path="/chat" name="Chat" component={Chat} />
						<Route path="/profil" name="Profil" component={Profil} />
						<Route path="/tahun_ajar" name="Tahun Ajar" component={TahunAjar} />
						<Route path="/pasien" name="Data Pasien" component={DataPasien} />
						<Route path="/transaksi" name="Transaksi" component={Transaksi} />
						<Route
							path="/histori_transaksi"
							name="Histori Transaksi"
							component={HistoriTransaksi}
						/>
						<Route path="/penagihan" name="Penagihan" component={Penagihan} />
						<Route path="/mapel" name="Mata Pelajaran" component={Mapel} />
						<Route path="/kelas" name="Kelas" component={Kelas} />
                        <Route path="/NaikKelas" name="NaikKelas" component={NaikKelas} />
						<Route path="/event" name="Event" component={Event} />
						<Route path="/news" name="Event" component={News} />
						<Route path="/help" name="Help" component={Help} />
						<Route path="/user-online" name="Online" component={Online} />
						<Route path="/pengumuman" name="Pengumuman" component={Pengumuman} />						
						<Route path="/prestasi" name="Pengumuman" component={Prestasi} />						
						<Route path="/static-page" name="Event" component={StaticPage} />
						<Route path="/jadwal" name="Jadwal" component={Jadwal} />
						<Route path="/users" name="Data User" component={Users} />
						<Route path="/tugas" name="Tugas" component={Tugas} />
						<Route path="/materi" name="Materi" component={Materi} />
						<Route path="/video" name="Video" component={Video} />
						<Route path="/exam" name="Ujian" component={Exam} />
						<Route path="/spp" name="Spp" component={Spp} />
						<Route path="/soal" name="Soal" component={Soal} />
						<Route path="/libur" name="Libur" component={Libur} />
						<Route path="/setting" name="Setting" component={Setting} />
						<Route path="/masteriuran" name="Masteriuran" component={MasterIuran} />
						<Route path="/diskoniuran" name="Diskoniuran" component={DiskonIuran} />
						<Route path="/forwardiuran" name="Forwardiuran" component={ForwardIuran} />
						<Route path="/jenisiuran" name="jenisiuran" component={JenisIuran} />
						<Route path="/groupiuran" name="groupiuran" component={GroupIuran} />
						<Route path="/iuransiswa" name="iuransiswa" component={IuranSiswa} />
						<Route path="/shift" name="shift" component={Shift} />
						<Route path="/arsip" name="Arsip" component={Arsip} />

						{/* Report Presensi*/}
						<Route path="/reportpresensi" name="Report Presensi" component={ReportPresensi} />

						<Redirect from="/" to="/dashboard" />
					</Switch>
				</div>
			</main>
			<Aside />
		</div>

	</div>
);

const mapStateToProps = state => ({
	itemAnggaran: state.itemAnggaran
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/App.js